import { IExpertBio } from "contentful-types"
import { getContentfulClient } from "lib/contentful/contentfulClient"
import ContentTypes from "utils/ContentTypes"
import { getContentfulLocale } from "../../../lib/contentful/utils/contenfulLocaleUtils"

export const getExpertBios = async (locale: string): Promise<IExpertBio[]> => {
  const client = getContentfulClient()
  const { items } = await client.getEntries({
    content_type: ContentTypes.EXPERTBIO,
    include: 2,
    locale: getContentfulLocale(locale)
  })
  return items as IExpertBio[]
}
